module.exports = __webpack_public_path__ + "static/media/date-img.23c31f98.svg";